module.exports = __webpack_public_path__ + "63ef25f736ff17a8d99679c8e92e606f.png";